import { DOCUMENT } from "@angular/common";
import { Inject, Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ThemeService {
  isDarkTheme = false;

  constructor(@Inject(DOCUMENT) private _document: Document) {}

  addTheme(theme: string) {
    this._document.documentElement.classList.add(theme);
  }

  removeTheme(theme: string) {
    this._document.documentElement.classList.remove(theme);
  }

  checkActiveDarkTheme() {
    if (localStorage.getItem("Equora_Selected_Theme") == "dark") {
      this.addTheme("dark");
      this.isDarkTheme = true;
    } else if (localStorage.getItem("Equora_Selected_Theme") == "light") {
      this.removeTheme("dark");
      this.isDarkTheme = false;
    }
  }

  toggleTheme() {
    this.isDarkTheme = !this.isDarkTheme;
    if (this.isDarkTheme) {
      localStorage.setItem("Equora_Theme", "dark");
      this.addTheme("dark");
    } else {
      localStorage.setItem("Equora_Theme", "light");
      this.removeTheme("dark");
    }
  }
}
